import { postcodeValidator } from 'postcode-validator';

export function extendValidators(VeeValidate) {
  VeeValidate.Validator.extend(
    'enum',
    {
      validate: (value, params) => {
        return params.values.includes(value);
      },
      getMessage: (field, params) => {
        return `can be only: ${params[0].join(', ')}`;
      },
    },
    {
      paramNames: ['values'],
    }
  );

  VeeValidate.Validator.extend(
    'postalCode',
    {
      validate: (value, { country }) => {
        try {
          return postcodeValidator(value, country);
        } catch (e) {
          if (e.toString().match(/Invalid country code/)) {
            return true;
          }
          return false;
        }
      },
      getMessage: (field) => {
        return `The ${field} code is not valid for the selected country.`;
      },
    },
    {
      paramNames: ['country'],
    }
  );

  VeeValidate.Validator.extend('maxVal', {
    getMessage(field, params) {
      return `Field should be less than ${params}`;
    },
    validate: (value, [testProp]) => {
      return parseFloat(value) <= parseFloat(testProp);
    },
  });

  VeeValidate.Validator.extend('minVal', {
    getMessage(field, params) {
      return `Field should be more than ${params}`;
    },
    validate: (value, [testProp]) => {
      return parseFloat(value) >= parseFloat(testProp);
    },
  });

  VeeValidate.Validator.extend('increment', {
    getMessage(field, params) {
      return `Field should be divisible by ${params}`;
    },
    validate: (value, [testProp]) => {
      return parseInt(value) % parseFloat(testProp) === 0;
    },
  });

  VeeValidate.Validator.extend('partSizes', {
    getMessage(field, params) {
      return `Error`;
    },
    validate: async (value, [testProp]) => {
      return testProp === 1;
    },
  });

  const dict = {
    custom: {
      Quantity: {
        min_value: (field, val) => `Please enter a quantity of ${val} or greater`,
      },
    },
  };

  VeeValidate.Validator.localize('en', dict);
}
